export enum HospitalDomainClassification {
  HOSPITAL = 'HOSPITAL',
  HOSPITAL_NETWORK = 'HOSPITAL_NETWORK',
  HOSPITAL_FOUNDATION = 'HOSPITAL_FOUNDATION',
  HOSPITAL_AUXILIARY = 'HOSPITAL_AUXILIARY',
  SHARED_LABORATORY = 'SHARED_LABORATORY',
  RESEARCH_INSTITUTE = 'RESEARCH_INSTITUTE',
  HOSPITAL_DIGITAL_SERVICE = 'HOSPITAL_DIGITAL_SERVICE',
  SHARED_ADMINISTRATION = 'SHARED_ADMINISTRATION',
  SHARED_CLINICAL_SERVICE = 'SHARED_CLINICAL_SERVICE',
  SHARED_GOVERNMENT = 'SHARED_GOVERNMENT',
  AFFILIATED_INSTITUTE = 'AFFILIATED_INSTITUTE',
  HOSPITAL_RESEARCH = 'HOSPITAL_RESEARCH',
  HOSPITAL_NETWORK_FOUNDATION = 'HOSPITAL_NETWORK_FOUNDATION',
}

/** Access this domain may grant. Admin/SpecialAccess are not assigned here. */
export type HospitalGrantedAccessLevel = 'PUBLIC' | 'ONTARIO_HEALTHCARE_PROFESSIONALS';

export const HOSPITAL_DOMAIN_CLASSIFICATION_LABELS: Record<HospitalDomainClassification, string> = {
  [HospitalDomainClassification.HOSPITAL]: 'Hospital',
  [HospitalDomainClassification.HOSPITAL_NETWORK]: 'Hospital network',
  [HospitalDomainClassification.HOSPITAL_FOUNDATION]: 'Hospital foundation',
  [HospitalDomainClassification.HOSPITAL_AUXILIARY]: 'Hospital auxiliary',
  [HospitalDomainClassification.SHARED_LABORATORY]: 'Shared laboratory',
  [HospitalDomainClassification.RESEARCH_INSTITUTE]: 'Research institute',
  [HospitalDomainClassification.HOSPITAL_DIGITAL_SERVICE]: 'Hospital digital service',
  [HospitalDomainClassification.SHARED_ADMINISTRATION]: 'Shared administration',
  [HospitalDomainClassification.SHARED_CLINICAL_SERVICE]: 'Shared clinical service',
  [HospitalDomainClassification.SHARED_GOVERNMENT]: 'Shared government',
  [HospitalDomainClassification.AFFILIATED_INSTITUTE]: 'Affiliated institute',
  [HospitalDomainClassification.HOSPITAL_RESEARCH]: 'Hospital / research',
  [HospitalDomainClassification.HOSPITAL_NETWORK_FOUNDATION]: 'Hospital network / foundation',
};

export const HOSPITAL_GRANTED_ACCESS_LABELS: Record<HospitalGrantedAccessLevel, string> = {
  PUBLIC: 'No extra access',
  ONTARIO_HEALTHCARE_PROFESSIONALS: 'Ontario Healthcare Professional',
};

export const FOUNDATION_LIKE_CLASSIFICATIONS: ReadonlySet<HospitalDomainClassification> = new Set([
  HospitalDomainClassification.HOSPITAL_FOUNDATION,
  HospitalDomainClassification.HOSPITAL_AUXILIARY,
]);

export function defaultGrantedAccessLevel(
  classification: HospitalDomainClassification
): HospitalGrantedAccessLevel {
  return FOUNDATION_LIKE_CLASSIFICATIONS.has(classification)
    ? 'PUBLIC'
    : 'ONTARIO_HEALTHCARE_PROFESSIONALS';
}

export interface OhpHospitalSite {
  id: string;
  name: string;
  domains: string[];
}

export interface OhpHospitalDirectory {
  domains: string[];
  sites: OhpHospitalSite[];
}

export interface HospitalEmailDomain {
  id: string;
  siteId: string;
  domain: string;
  classification: HospitalDomainClassification;
  organizationOrService: string | null;
  verificationStatus: string | null;
  sourceUrl: string | null;
  notes: string | null;
  reviewedAt: string | null;
  grantedAccessLevel: HospitalGrantedAccessLevel;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface HospitalSite {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  domains: HospitalEmailDomain[];
}

export interface HospitalSiteListQuery {
  search?: string;
  classification?: HospitalDomainClassification | '';
  grantedAccessLevel?: HospitalGrantedAccessLevel | '';
  active?: '' | 'true' | 'false';
}

export interface CreateHospitalEmailDomainInput {
  domain: string;
  classification: HospitalDomainClassification;
  grantedAccessLevel?: HospitalGrantedAccessLevel;
  active?: boolean;
  organizationOrService?: string | null;
  notes?: string | null;
  sourceUrl?: string | null;
}

export type UpdateHospitalEmailDomainInput = Partial<CreateHospitalEmailDomainInput>;
